module.exports = __webpack_public_path__ + "static/media/motorista_carteira.0f899de3.png";